module.exports = __webpack_public_path__ + "img/dai.b7ea7efe.png";